import { render, staticRenderFns } from "./EditComponent.vue?vue&type=template&id=678abe66&"
import script from "./EditComponent.vue?vue&type=script&lang=js&"
export * from "./EditComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports